/**
 * ページにメソッドが既に適用されているかどうかをチェックする。適用されている場合はtrueを返す。
 *
 * @param {string} methodName
 * @returns {boolean}
 */
export function checkIfApplied(methodName) {
    const mtappSystem = (window.mtappVars.__system = window.mtappVars.__system || {});

    if (methodName === 'duplicate' || methodName === 'duplicateContent') {
        if (typeof mtappSystem.hasDuplicateFunction === 'undefined') {
            mtappSystem.hasDuplicateFunction = true;
            return false;
        }
        return true;
    }

    return false;
}
